import { render } from "./AppStyle.vue?vue&type=template&id=168c7d68&lang=pug"
import script from "./AppStyle.vue?vue&type=script&lang=js"
export * from "./AppStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__